const handlerErrors = error => {
    console.log(error)
    if (error.response) {
        return error.response.data
    } else if (error.request) {
        return { status: false, message: 'Problema ao enviar solicitção, verifique sua conexão com a internet.' }
    } else {
        return { status: false, message: 'Error ao processar sua solicitação.' }
    }        
}

export default handlerErrors


// WEBPACK FOOTER //
// ./src/helpers/handlerErrorsAxios.js